import capitalize from 'lodash/capitalize'
import trim from 'lodash/trim'
import snakeCase from 'lodash/snakeCase'

export const humanizeString = (str) => {
  return capitalize(trim(snakeCase(str).replace(/_id$/, '').replace(/_/g, ' ')))
}

export const formatPercentageChange = (value) => {
  if (value > 0) {
    return { text: `+${value}%`, color: 'secondary-main' }
  } else if (value < 0) {
    return { text: `${value}%`, color: 'error' }
  }
  return { text: 'No improvement', color: 'default' } // Default case
}
